import { getAuthToken } from "../context/auth-context";
import { CALL_API } from "../context/constValues";
export async function insertAdmin(objeto) {
  const {
    cuenta,
    contraseña,
    nombre,
    cedula,
    foto,
    accesos
  } = objeto;
  // Validar campos requeridos
  if (!cuenta || !contraseña || !nombre || !cedula) {
    throw new Error("Los campos cuenta, contraseña, nombre completo y cédula son obligatorios.");
  }

  const token = getAuthToken();
  const formData = new FormData();
  formData.append("cuenta", cuenta);
  formData.append("contrasena", contraseña);
  formData.append("nombrecompleto", nombre);
  formData.append("cedula", cedula);

  // Recorrer la estructura de accesos anidados y agregarlos al FormData
  // El nombre del campo será: `${grupo}_${subacceso}` en minúsculas y sin espacios
  Object.entries(accesos).forEach(([grupo, subaccesos]) => {
    Object.entries(subaccesos).forEach(([subacceso, valor]) => {
      // E.g. Ventas.Clientes => ventas_clientes
      const fieldName = `${grupo}_${subacceso}`.toLowerCase().replace(/\s+/g, "");
      formData.append(fieldName, valor ? "true" : "false");
    });
  });

  if (foto instanceof File) {
    // Renombrar la foto con la cédula, preservando la extensión
    const extension = foto.name.split(".").pop();
    const nuevoNombre = `${cedula}.${extension}`;
    formData.append("image", foto, nuevoNombre);
    formData.append("foto", nuevoNombre); // Guardar el nombre del archivo
  }

  try {
    const response = await fetch(`${CALL_API}/InsertAdmin`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Error al registrar el usuario");
    }
    return data.isCreated;
  } catch (error) {
    console.error("Error en insertAdmin:", error);
    throw error;
  }
}
export async function updateAdmin(objeto) {
  const {
    idadmin,
    cuenta,
    contraseña,
    nombre,
    cedula,
    foto,
    accesos
  } = objeto;
  // Validar campos requeridos
  if (!idadmin) {
    throw new Error("El ID del administrador es obligatorio.");
  }
  if (!cuenta || !nombre || !cedula) {
    throw new Error("Los campos cuenta, nombre completo y cédula son obligatorios.");
  }

  const token = getAuthToken();
  const formData = new FormData();
  formData.append("cuenta", cuenta);
  // Solo incluir contraseña si se proporciona (para modo edición)
  if (contraseña) {
    formData.append("contrasena", contraseña);
  }
  formData.append("nombrecompleto", nombre);
  formData.append("cedula", cedula);

  // Recorrer la estructura de accesos anidados y agregarlos al FormData
  // El nombre del campo será: `${grupo}_${subacceso}` en minúsculas y sin espacios
  Object.entries(accesos).forEach(([grupo, subaccesos]) => {
    Object.entries(subaccesos).forEach(([subacceso, valor]) => {
      // E.g. Ventas.Clientes => ventas_clientes
      const fieldName = `${grupo}_${subacceso}`.toLowerCase().replace(/\s+/g, "");
      formData.append(fieldName, valor ? "true" : "false");
    });
  });

  // Manejar la imagen
  if (foto instanceof File) {
    // Si se sube una nueva imagen, renombrarla con la cédula
    const extension = foto.name.split(".").pop();
    const nuevoNombre = `${cedula}.${extension}`;
    formData.append("image", foto, nuevoNombre);
    formData.append("foto", nuevoNombre); // Guardar el nombre del archivo
  } else if (foto) {
    // Si no se sube una nueva imagen, usar la existente
    formData.append("foto", foto);
  }
  try {
    const response = await fetch(`${CALL_API}/UpdateAdmin/${idadmin}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formData
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Error al actualizar el usuario");
    }

    return data.isSaved;
  } catch (error) {
    console.error("Error en updateAdmin:", error);
    throw error;
  }
}
export async function getAllAdmin() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/admin`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontro informacion");
  }
  return data.admins;
}
export async function UpdateEstadoAdmin(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/updateEstadoAdmin/${id}`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    }
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontro informacion");
  }
  return data;
}
export async function changePassword(usuarioObject) {
  const { newPassword, currentPassword } = usuarioObject;
  const token = getAuthToken();
  const result = await fetch(`${CALL_API}/resetAdminPass/`, {
    method: "PATCH",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      newPassword,
      currentPassword
    }),
  });

  const data = await result.json();
  if (!result.ok) {
    throw new Error(data.message);
  }

  return data.isReset;
}
export async function loginAdmin(usuarioObject) {
  const { usuario, password } = usuarioObject;
  const response = await fetch(`${CALL_API}/loginAdmin`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      usuario: usuario,
      password: password,
    }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message);
  }

  return data.token;
}
export async function getAdminById(idUsuario) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/admin/${idUsuario}`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontro informacion");
  }
  return data.result;
}
export async function getAdminCredentials() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/admin-credentials`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message);
  }
  return data.userData;
}
export async function changePasswordAdmin(usuarioObject) {
  const { newPassword, idadmin, cuenta } = usuarioObject;
  const token = getAuthToken();
  const result = await fetch(`${CALL_API}/resetAdminPass2/`, {
    method: "PATCH",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      newPassword,
      idadmin,
      usuario: cuenta
    }),
  });

  const data = await result.json();
  if (!result.ok) {
    throw new Error(data.message);
  }

  return data.isReset;
}
export async function getAllCondiciones() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/condiciones`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error("No se encontro informacion");
  }
  return data
}
export async function insertCondicion(objeto) {
  const { cod, condicion } = objeto;

  // Validar campos requeridos
  if (!cod || !condicion) {
    throw new Error("Los campos código y condición son obligatorios.");
  }

  const token = getAuthToken();
  const payload = { cod, condicion };

  try {
    const response = await fetch(`${CALL_API}/insertCondicion`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Error al registrar la condición");
    }
    return data.isSaved;
  } catch (error) {
    console.error("Error en insertCondicion:", error);
    throw error;
  }
}
export async function updateCondicion(objeto) {
  const { idcondiciones, cod, condicion } = objeto;
  // Validar campos requeridos
  if (!idcondiciones || !cod || !condicion) {
    throw new Error("Los campos idcondiciones, código y condición son obligatorios.");
  }

  const token = getAuthToken();
  const payload = { cod, condicion };

  try {
    const response = await fetch(`${CALL_API}/condiciones/${idcondiciones}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Error al actualizar la condición");
    }
    return data.isSaved;
  } catch (error) {
    console.error("Error en updateCondicion:", error);
    throw error;
  }
}